let inMemoryCache = {};

export function getFromInMemory(key) {
  return inMemoryCache[key];
}

export function setToInMemory(key, value, sync = false) {
  inMemoryCache[key] = value;

  // sync thing need to be done

  /**
   * @Question
   *  @Arihant -> @Abinash
   *  What is this sync thing Anusheel commented?
   */
}
